import { TemplatePage } from './types';
import { TEMPLATES_AMOUNT } from '@anm/constants/templates_amount';

const businessPage: TemplatePage = {
  header: {
    color: '#FED07A',
    icon: 'images/video-templates/business.jpg',
    title: 'Business Video Templates Collection',
    title_meta: '50+ Free and Customizable Business Video Templates',
    description_meta:
      'Discover 50+ business video templates to kick-off your video production and promote your brand. Effortless video ' +
      'making for your business with Wave.video.',
    description:
      'These video templates are cut out for business-specific messaging. Promote your online or offline events, share ' +
      'the latest industry news and explore new networking opportunities. Make your business flourish with the power of ' +
      'video.'
  },
  footer: {
    category: 'Business',
    description:
      'Easily editable video templates help you create quality and diverse video content in a short time. They are ' +
      'designed by professionals, hence you don’t need to worry about being a non-designer or learn complicated video ' +
      `editing software. With Wave.video, you get all the tools to shape any of ${TEMPLATES_AMOUNT}+ video templates into eye-catching ` +
      'branded video content. All templates come in various formats so that you can create corresponding videos for all ' +
      'social media platforms and other marketing channels.'
  },
  content: [
    {
      type: 'templates',
      title: 'Business Video Templates',
      search: { category: '/Industries/Business' }
    },
    {
      type: 'stocks',
      title: 'business',
      search: { name: 'business' }
    },
    { type: 'calendar' }
  ]
};

export default businessPage;
